import theme from '../../themes/green';

const styles = {
  wrapper: {
    height: 30,
    display: 'flex',
    alignItems: 'center',
    padding: '0 10px',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    transition: theme.transitions.slow,
    ':hover': {
      backgroundColor: theme.pallete.hover,
    },
  },
  selected: {
    backgroundColor: theme.pallete.light,
  },
  text: {
    flex: 1,
    fontSize: 11,
    whiteSpace: 'nowrap',
  },
  icon: {
    marginRight: 10,
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/SelectableListItem/styles.js